
/**
 * Animate a current tab underline from tab to tab 
 * @returns {void}
 */
export default function decorUnderline(elem, indicator) {

    let curTab = elem.querySelector('.tabs-tab.-current');
    if(!curTab) {
        return;
    }
    let curTabWidth = curTab.getBoundingClientRect().width;
    let distance = curTab.getBoundingClientRect().left;

    indicator.style.left = `${distance}px`;
    indicator.style.width = `${curTabWidth}px`;
    
}